import { getOssTokenApi } from '@/api'
import { uuidWithoutHyphen } from '@/utils/uuid'
import moment from 'moment'
import OSS from 'ali-oss'
// 图片上传oss
export const uploadImg = (files) => {
  return new Promise(async (resolve, reject) => {
    try {
      const fileToUpload = await imageCompression(files.file)
      // 1. 获取STS临时凭证
      const data = await getOssTokenApi()
      // 2. 初始化OSS客户端
      const client = new OSS({
        region: data.data.region,
        accessKeyId: data.data.accessKeyId,
        accessKeySecret: data.data.accessKeySecret,
        stsToken: data.data.securityToken,
        bucket: data.data.bucket
      })
      let suffixMatch = fileToUpload.name.match(/\.([^.]+)$/)
        ? fileToUpload.name.match(/\.([^.]+)$/)[0]
        : ''
      if (!suffixMatch) {
        suffixMatch = fileToUpload.type.match(/\/(.+)/)
          ? `.${fileToUpload.type.match(/\/(.+)/)[1]}`
          : fileToUpload.name
      }
      const fileName = `${process.env.VUE_APP_OSS_PREFIX}/upload/${moment().format(
        'YYYYMM'
      )}/${uuidWithoutHyphen()}${suffixMatch}`
      // 4. 上传文件到OSS
      const result = await client.put(fileName, fileToUpload, {
        progress: (p) => {
          // console.log(`上传进度: ${Math.round(p * 100)}%`);
        }
      })
      result.url = data.data.domain + fileName
      resolve(result)
      // console.log('OSS文件URL:', result);
      // 5. 上传成功后处理
      // await this.$http.post('/api/save-file', { url: result.url });
      // this.$message.success('上传成功！');
    } catch (error) {
      // this.storeForm.imgUrl = []
      // this.storeForm.imgUrl.splice(detail.index, 1)
      console.log('上传失败:', error)
      // this.$message.error('上传失败，请重试！');
      reject('Upload Failed1')
    }
  })
}

// 图片压缩
export const imageCompression = (file) => {
  return new Promise((resolve, reject) => {
    // 添加文件大小判断（1MB = 1024*1024 = 1048576 bytes）
    if (file.size <= 1024 * 1024) {
      resolve(file)
      return
    }
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (e) => {
      const img = new Image()
      img.src = e.target.result
      img.onload = () => {
        let width = img.width
        let height = img.height
        // 按比例调整尺寸
        if (width > 1000) {
          height *= 1000 / width
          width = 1000
        }
        if (height > 1000) {
          width *= 1000 / height
          height = 1000
        }
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = width // 设置压缩后图片的宽度
        canvas.height = height // 根据原始图片比例计算压缩后图片的高度
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        canvas.toBlob((blob) => {
          // return true
          const compressedFile = new File([blob], file.name, {
            type: file.type,
            lastModified: Date.now()
          });
          resolve(compressedFile)
          // return file
        }, file.type)
      }
    }
  })
}
